export const alignment = '';
export const offset = {};
export const minWidth = -1;
